// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message[data-v-1429a633]{height:100%}.message__title[data-v-1429a633]{font-size:1.75rem;line-height:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
